<template>
  <div v-if="onShow" class="full-reduction-pop">
    <div class="contentPop">
      <img
        @click="onClose"
        class="closed"
        src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/closed.png"
        alt=""
      />
      <img
        class="success"
        src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/success.png"
        alt=""
      />
      <h3>会员激活成功！</h3>
      <div class="checkbtn"  @click="myCourse">查看会员</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onShow: Boolean,
  },
  data() {
    return {

    };
  },
  mounted() {},
  methods: {
    myCourse() {
      if (this.$root.$data.isApp) {
        const url = `${window.location.origin}/ark/personalCenter/member?hiddenNavigationBar=1`;
        this.$sendToApp('openNewWebView', { url }, false);
      } else {
        this.$router.push({ path: '/personalCenter/member' });
      }
    },
    onClose() {
      this.$emit('changeShow');
    },
  },
};
</script>
<style scoped lang="scss">
.full-reduction-pop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.3);
  .contentPop {
    position: relative;
    top: 50%;
    width: 654px;
    height: 430px;
    margin: 0 auto;
    padding-top: 80px;
    background: #fff;
    border-radius: 16px;
    transform: translateY(-50%);
    .closed {
      position: absolute;
      top: 30px;
      right: 30px;
      width: 24px;
      height: 24px;
    }
    .success {
      display: block;
      width: 96px;
      height: 96px;
      margin: 0 auto;
    }
    h3 {
      margin: 44px 0;
      color: #000;
      font-weight: 400;
      font-size: 28px;
      text-align: center;
    }
    .checkbtn {
      width: 324px;
      height: 76px;
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 32px;
      line-height: 76px;
      text-align: center;
      background: #ff7f41;
      border-radius: 50px;
    }
  }
}
</style>
